<template>
    <div class="register-comp">
        <head-nav-bar
            :pageName="navbarName"
            :isShowBack="true"
            @clickBack="clickBack()"
        ></head-nav-bar>
        <div class="register-body">
            <div class="register-headline theme-txt">{{lbl.register_form_headline}}</div>
            <div id="rf_form">
                <TextInput
                    addClass="rf-input"
                    :errorInfo="errorInfo[0]"
                    inputId="register_firstname"
                    :inputLbl="lbl.name"
                    :inputMaxLength="60"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :isTextOnly="true"
                    :isHideLabel="true"
                    v-model="name"
                    @input="onFormUpdate()" />
                <TextInput
                    addClass="rf-input"
                    :errorInfo="errorInfo[1]"
                    inputId="register_lastname"
                    :inputLbl="lbl.lastname"
                    :inputMaxLength="60"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :isTextOnly="true"
                    :isHideLabel="true"
                    v-model="lastname"
                    @input="onFormUpdate()" />
                <Email
                    addClass="rf-input"
                    :errorInfo="errorInfo[2]"
                    inputId="register_email"
                    :inputLbl="lbl.email"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :isHideLabel="true"
                    v-model="email"
                    @input="onFormUpdate()" />
                <ContactNumber
                    addClass="rf-input"
                    addInputClass="theme-txt"
                    :blockAutoComplete="true"
                    delimeter="-"
                    :errorInfo="errorInfo[3]"
                    inputId="register_contact_number"
                    :inputLbl="lbl.contact_number_register"
                    :isReadOnly="true"
                    :isHideLabel="true"
                    v-model="contact_number"
                    @input="onFormUpdate()" />
                <BirthDateInput
                    :errorInfo="errorInfo[4]"
                    :inputLbl="lbl.birthdate"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :isRegister="true"
                    @onDateChange="onDateChange($event)" />
                <div class="warning" v-if="isAcceptAge">{{lbl.birthdate.warning_age}}</div>
                <ShopInput
                    ref="shop_info"
                    :lbl="lbl"
                    :errorInfo="errorInfo[5]"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :modalController="modalController"
                    :shopInfo="shopInfoExisting"
                    @inputShop="onFormUpdate($event)" />
                <!-- <ShopInput
                    v-else
                    ref="shop_info"
                    :lbl="lbl"
                    :errorInfo="errorInfo[5]"
                    :isShowError="true"
                    :isSubmitted="isSubmitted"
                    :modalController="modalController"
                    :shopInfo="shopInfo"
                    @inputShop="onFormUpdate($event)" /> -->
            </div>
        </div>
        <div class="px-4">
            <div id="rf_terms">
                <div class="cb-icon" :class="{'cb-icon-selected': isAcceptTerm}"
                    @click="clickAcceptTerms()"></div>
                <div class="cb-txt">
                    {{lbl.terms_1}}
                    <span class="cb-link"
                          @click="clickTermsLink()">{{lbl.terms_2}}</span>{{lbl.terms_3}}
                </div>
                <div class="box-marketing cb-icon" :class="{'cb-icon-selected': isAcceptMarketing}"
                    @click="clickAcceptMarketing()"></div>
                <div class="cb-txt">
                    {{lbl.terms_1}}
                    <span class="cb-link"
                          @click="clickMarketingLink()">{{lbl.marketing.title}}</span>
                </div>
            </div>
            <div class="pt-0 pb-4">
                <div id="rf_submit_form"
                    class="btn-wrapper" v-if="isBtnDisable">
                    <div class="btn-txt"
                        @click="clickSubmitForm()">{{lbl.submit_form_btn}}</div>
                </div>
                <div id="rf_submit_form"
                    class="btn-wrapper btn-disable" v-else>
                    <div class="btn-txt">{{lbl.submit_form_btn}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// helper
import FormHelper from '@/helper/FormHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
// error
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// controller
import AnimalBreedController from '../controller/AnimalBreedController.js';
// components
import HeadNavBar from "@/components/Layout/NavBar/NavBar.vue";
// import RegisterAnimalForm from '@/module/Register/component/RegisterAnimalForm.vue';
// input components
import BirthDateInput from '@/components/Input/BirthDateInput.vue';
import ContactNumber from '@/components/Input/ContactNumber.vue';
import Email from '@/components/Input/Email.vue';
import ShopInput from '@/components/Share/ShopInput.vue';
import TextInput from '@/components/Input/Text.vue';
export default {
    name: 'register-form',
    components: {
        HeadNavBar,
        // RegisterAnimalForm,
        BirthDateInput,
        ContactNumber,
        Email,
        ShopInput,
        TextInput
    },
    mixins: [
        ErrorApiMixin
    ],
    props: {
        lbl: Object,
        userType: String,
        contactNumber: String,

        modalController: Object,
        busPage: Object
    },
    computed: {
        registerState: function () {
            return this.$store.state.state;
        },
        registerUserType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            navbarName: this.lbl.register_form_navbar_name,

            name: '',
            lastname: '',
            email: '',
            birthdate: null,
            contact_number: '',
            displayContactNumber: '',
            shopInfo: {
                province: null,
                shopName: null,
            },
            isAcceptTerm: false,
            isAcceptMarketing: false,
            isAcceptAge: false,
            isSubmitted: false,
            isValid: false,
            marketing: {
                email: null,
                sms: null,
                line: null,
                notification: 1,
            },

            errorHandler: null,
            errorInfo: [],

            isAnimalConfigLoaded: false,
            trackingService: new TrackingService(this),
            trackingCategory: 'register_page',
            //controller
            animalBreedController: new AnimalBreedController(),

            isBtnDisable: false,
            isSelectedShop: false,

            shopInfoExisting: null
        };
    },
    created: function () {
        this.animalBreedController.setLbl(this.lbl);

        this.errorInfo = FormHelper.genErrorInfo(6);
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setTitle(this.lbl.register_alert_headline);
    },
    mounted: function () {
        this.busPage.$on('initialForm', this.initialForm);
    },
    methods: {
        //initial
        initialForm: function (data) {
            console.log(data);
            
            if (data.userInfo) {
                this.inputExistUser(data.userInfo, data.contactNumber);
                
                if (data.userInfo.Province == '') {
                    this.shopInfoExisting = {
                        Province: '',
                        ShopName: '',
                    };
                } else {
                    this.shopInfoExisting = data.userInfo;
                }
            } else {
                this.formatContactNumber(data.contactNumber);
            }
        },
        initialCallback: function () {
            this.animalBreedController
                .cbLoaded
                .onCallback(() => {
                    this.isAnimalConfigLoaded = true;
                });

            this.animalBreedController
                .cbError
                .onCallback(err => {
                    this.errorResponse(err, this.errorHandler);
                });
        },
        //Event
        clickBack: function () {
            this.$store.commit('changeUserType', 'farmer');
            this.$store.commit('changeState', 'contact_number');
        },
        clickAcceptTerms: function () {
            this.isAcceptTerm = !this.isAcceptTerm;
            console.log(this.isAcceptTerm);
            
            this.onFormUpdate();

            this.trackingService.event(this.trackingCategory, 'click_accept', null, null)
        },
        clickAcceptMarketing: function () {
            this.isAcceptMarketing = !this.isAcceptMarketing;

            if(this.isAcceptMarketing){
                this.marketing = {
                    all: true,
                    email: true,
                    sms: true,
                    line: true,
                    noti: true,
                }
            }else{
                this.marketing = {
                    all: false,
                    email: false,
                    sms: false,
                    line: false,
                    noti: false,
                }
            }
            this.$emit('marketing', this.marketing);
        },
        clickTermsLink: function () {
            this.modalController
                .termsModal
                .clearText()
                .setTag('register-terms')
                .setTitle(this.lbl.terms_headline_modal)
                .setBtnAcceptTerms(this.lbl.btn_accept)
                .setAcceptTerms(this.isAcceptTerm)
                .show();

            this.modalController
                .termsModal
                .onAcceptTerms((data)=> {
                    if(data){
                        this.isAcceptTerm = true;
                        this.onFormUpdate();
                    }
                });
        },
        clickMarketingLink: function () {
            this.modalController
                .marketingRegisterModal
                .clearText()
                .setTag('register-marketing')
                .setTitle(this.lbl.marketing.title)
                .setBtnAcceptMarketing(this.lbl.btn_accept)
                .setAcceptMarketing(this.isAcceptMarketing)
                .show();

            this.modalController
                .marketingRegisterModal
                .onAcceptMarketing((data)=> {
                    if(data){
                        this.isAcceptMarketing = true;
                    }
                    this.$emit('marketing', data.marketing);
                });
            this.modalController
                .marketingRegisterModal
                .onAcceptConfirmMarketing((data)=> {
                    if(data){
                        this.modalController
                            .marketingRegisterModal
                            .clearText()
                            .setTag('register-marketing')
                            .setTitle(this.lbl.marketing.title)
                            .setBtnAcceptMarketing(this.lbl.btn_accept)
                            .show();
                    }
                });
            this.modalController
                .marketingRegisterModal
                .onCancelMarketing((data)=> {
                    if(data){
                        this.isAcceptMarketing = false;
                    }
                });
        },
        clickSubmitForm: function () {
            this.isSubmitted = true;
            this.validateAge();
            if (this.isAcceptAge) {
                return
            } else {
                this.validator();
            }
            this.trackingService.event(this.trackingCategory, 'click_register_confirm', null, null)
        },
        onDateChange: function (selectedBirthDate) {
            if (!selectedBirthDate) return;

            this.birthdate = selectedBirthDate.timestamp;
            this.onFormUpdate();
        },
        //Validate
        validator: function () {
            const isValid = FormHelper.validate(this.errorInfo);
            const header_lbl = this.lbl.register_alert_headline;
            if (!isValid) {
                this.showAlert(header_lbl, this.lbl.fields_required, this.lbl.register_alert_btn);
                return;
            }

            if (!this.isAcceptTerm) {
                this.showAlert(header_lbl, this.lbl.terms_accept_require, this.lbl.register_alert_btn);
                return;
            }

            this.shopInfo = this.$refs['shop_info'].getShopInfo();
            
            //for enable button
            let registerData = {
                name: this.name,
                lastname: this.lastname,
                email: this.email,
                birthdate: this.birthdate,
                shopinfo: this.shopInfo
            };
            this.$emit('register', registerData);
        },
        validateAge: function(){
             //check age for consent
            var currentDate = new Date();
            var convertBirthDate = DatetimeHelper.convertTimeStampUnixToDate(this.birthdate);
            var isBirthDate = new Date(convertBirthDate);
            var difference = currentDate - isBirthDate;
            var age = Math.floor(difference/31557600000);
            this.isAcceptAge = false;
            if (age <= 20) {
                this.isAcceptAge = true;
            }
        },
        inputExistUser: function(infoUser, contactNumber) {
            this.contact_number = contactNumber;
            this.name = infoUser.Name;
            this.lastname = infoUser.Surname;
            this.email = infoUser.Email;
            this.birthdate = infoUser.Timestamp;
        },
        //Utilities
        formatContactNumber: function (contactNumber) {
            var n1, n2, n3;
            var displayContactNumber = contactNumber;
            var delimeter = '-';

            n1 = displayContactNumber.substr(0, 3);
            n2 = displayContactNumber.substr(3, 3);
            n3 = displayContactNumber.substr(6);
            displayContactNumber = n1 + delimeter + n2 + delimeter + n3;

            console.log(contactNumber);
            this.contact_number = contactNumber;
            this.displayContactNumber = displayContactNumber;
            // this.shopInfo = '';
        },
        //modal
        showAlert: function (title, msg, btn) {
            this.modalController.alertModal
                    .clearText()
                    .setTitle(title)
                    .setMsg(msg)
                    .setBtnOk(btn)
                    .setTag('alert-register-form')
                    .show();
        },
        onFormUpdate: function () {
            this.isValid = FormHelper.validate(this.errorInfo);
            this.shopInfo = this.$refs['shop_info'].getShopInfo();
            if (this.isValid && this.isAcceptTerm && (this.shopInfo && this.shopInfo.province != '') && this.birthdate != null) {
                this.isBtnDisable = true;
            } else {
                this.isBtnDisable = false;
            }
        },
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
@import "@/style/base/base.scss";
.register-comp {
    .register-body {
        .register-headline {
            margin-bottom: 25px;
            //font
            text-align: left;
        }
        .warning {
            color: $red_err;
            font-size: 1.25rem;
        }
    }
}

#rf_terms {
    @include checkbox-wrapper("../../../assets/icon/ic-checkbox-active-new.svg", "../../../assets/image/Register/ic-cb-inactive.svg");

    .cb-icon {
        margin: 10px 0;
        &.cb-icon-selected{
            &.dist {
                background-image: url("../../../assets/image/Register/ic-cb-dist-active.svg");
            }

            &.sale {
                background-image: url("../../../assets/image/Register/ic-cb-sale-active.svg");
            }
        }
    }
    .cb-txt {
        margin: 10px 0;
        color: $a-gray-575757;
        font-size: 1.5rem;
        .cb-link {
            color: $green-00987F;
            &.dist {
                color: $dist;
            }

            &.sale {
                color: $sale;
            }
        }
    }
}

#rf_farmer {
    padding-bottom: 10px;
}
</style>
<style lang="scss" >
@import "@/style/base/common.scss";
#rf_form {
    width: 100%;

    .rf-input {
        @include baseRegisterInput;
        margin-bottom: 25px;
    }
    .ep-input {
        @include baseRegisterInput;
        margin-bottom: 25px;
    }
}
</style>
